<div class="vtr-ui-rectangle-radio {{group}}"
	[ngClass]="{'border-blue':checked && !disabled, 'border-grey':!checked, 'disabled-class':disabled, 'disabled-grey':checked && disabled}"
	role="radio"
	id="{{'div' + radioId}}"
	#radioButton
	[tabIndex]="disabled ?-1:checked? 0 :-1"
	[attr.aria-disabled]="disabled"
	[attr.aria-checked]="checked"
	attr.aria-label="label"
	(keydown)="navigateByKeys($event,radio)">
	<input id="{{radioId}}"
		style="display: none;"
		[attr.aria-label]="label"
		name="{{group}}"
		type="radio"
		[value]="value"
		[checked]="checked"
		[disabled]="disabled"
		#radio
		(change)="onChange($event)"
		tabindex="-1"
		[attr.aria-checked]="checked" />
	<label for="{{radioId}}">

		<span *ngIf="!isTopRowFunction"
			class="label">{{label}}</span>
		<span *ngIf="isTopRowFunction"
			class="label"
			[innerHTML]="label"></span>
		<span class="{{iconName}} mt-3"></span>

		<span *ngIf="!hideIcon"
			[ngClass]="'icomoon icomoon-'+getIconName(label)"></span>
		<!--<fa-icon class="icon"
			[icon]="['far', 'gem']"></fa-icon>-->
		<span *ngIf="tooltip"
			class="question"
			placement="auto"
			ngbTooltip="{{tooltip}}"
			container="vtr-root">
			<fa-icon [icon]="['far', 'question-circle']"></fa-icon>
		</span>
	</label>
</div>
